import { createContext, use } from 'react';

import type { Theme } from './theme';

export interface ThemeContextValue {
  readonly theme: Theme;
  readonly setTheme: (theme: Theme) => void;
  readonly toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme(): ThemeContextValue {
  const value = use(ThemeContext);

  if (value === null) {
    throw new Error('useTheme must be used inside <ThemeProvider>');
  }

  return value;
}
